import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import LabelArea from "components/form/LabelArea";
import SelectVehicleCategory from "components/form/SelectVehicleCategory";
import React, { useState } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

const DynamicOnewayPeriodicHikeDayInput = ({
  setSelectedOptions,
  selectedOptions,
  setDataInput,
  dataInput,
  register,
  trigger,
  errors,
  handleVehicleCategoryChange,
  handleChange,
}) => {
  const handleClick = () => {
    setDataInput((prevData) => [
      ...prevData,
      {
        ["vehicle_type_" + prevData.length]: "",
        ["hike_" + prevData.length]: "",
      },
    ]);
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const handleDelete = () => {
    if (deleteIndex !== null) {
      setSelectedOptions((prevOptions) => {
        const deleteVal = dataInput[deleteIndex][`vehicle_type_${deleteIndex}`];
        return prevOptions.filter((option) => option !== deleteVal);
      });

      setDataInput((prevData) => {
        const newData = prevData.filter((_, index) => index !== deleteIndex);
        return newData.map((item, index) => ({
          [`vehicle_type_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("vehicle_type"))
            ] || "",
          [`hike_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("hike"))] || "",
        }));
      });

      setShowDeleteModal(false);
      setDeleteIndex(null);
    }
  };

  const confirmDelete = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  return (
    <div className="col-span-full relative">
      <div className="grid grid-cols-3 gap-5 col-span-8">
        <div>
          <LabelArea label={"Vehicle Type"} />
        </div>
        <div>
          <LabelArea label={"Hike"} />
        </div>
        {/* <div className="xl:hidden text-center underline underline-offset-8">
          Vehicles and Hike
        </div> */}
      </div>
      {dataInput.map((val, i) => (
        <div className="grid grid-cols-3 gap-5 mb-8 col-span-8" key={i}>
          <div className="">
            <SelectVehicleCategory
              register={register}
              label="Vehicle Type"
              name={`vehicle_type_${i}`}
              selectedVehicle={String(val[`vehicle_type_${i}`])}
              selectedOptions={selectedOptions}
              onChange={(e) => handleVehicleCategoryChange(e, i)}
              type="text"
              placeholder={"--Choose--"}
            />
            <Error errorName={errors[`vehicle_type_${i}`]} />
          </div>
          <div className="">
            <InputAreaPrice
              register={register}
              name={`hike_${i}`}
              label="Hike"
              type="text"
              maxLength={2}
              value={val[`hike_${i}`]}
              required={true}
              //defaultValue={val[`hike_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"Hike in %"}
            />
            <Error errorName={errors[`hike_${i}`]} />
          </div>

          <div className="flex items-center">
            {Object.keys(dataInput).length !== 1 && (
              <button
                style={{ top: "1rem", outline: "none", color: "grey" }}
                className="ml-8 outline-none"
                type="button"
                aria-label="Remove item"
                onClick={() => confirmDelete(i)}
              >
                X
              </button>
            )}
          </div>
        </div>
      ))}
      <div className="clear-both"></div>
      <div className="mt-6 lg:mt-1">
        <button
          style={{
            bottom: "-15px",
            color: "#0e9f6e",
            fontSize: "42px",
            outline: "none",
          }}
          className="absolute right-0 outline-none"
          type="button"
          onClick={handleClick}
        >
          +
        </button>
      </div>
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default DynamicOnewayPeriodicHikeDayInput;
